import {
  QUESTION_CERTIFIED_CARS,
  QUESTION_LEAD_TYPE,
  QUESTION_MAKE_MODEL,
  QUESTION_NEW_CARS,
  QUESTION_ORIGINAL_OWNER,
  QUESTION_USED_CARS,
  QUESTION_VEHICLE_AUCTION,
  QUESTION_VEHICLE_ISSUES,
  QUESTION_VEHICLE_RENTAL,
  QUESTION_YEAR_RANGE,
} from './utils.question';
import { isValidValue } from './utils.vehicle';

export const ANSWER_LEAD_TYPE_OPT_IN = 'OptIn';
export const ANSWER_LEAD_TYPE_CASH_OFFER = 'CashOffer';
export const ANSWER_LEAD_TYPE_OPT_OUT = 'OptOut';

export const findAnswerGroup = (answerKey: string = '', answerState) => {
  // Determine which group answer belongs to
  for (const group in answerState) {
    if (answerState[group][answerKey]) {
      return group;
    }
  }
};

export function getVehicleHistoryProperties(historyAnswers) {
  const isOriginalOwner = historyAnswers[QUESTION_ORIGINAL_OWNER]?.value;
  const hasVehicleIssues = historyAnswers[QUESTION_VEHICLE_ISSUES]?.value;
  const hasVehicleAuction = historyAnswers[QUESTION_VEHICLE_AUCTION]?.value;
  const hasVehicleRental = historyAnswers[QUESTION_VEHICLE_RENTAL]?.value;

  return {
    isOriginalOwner,
    hasVehicleIssues,
    hasVehicleAuction,
    hasVehicleRental,
  };
}

export function getReplacementVehicleProperties(replacementVehicle) {
  const leadTypeAnswer = replacementVehicle[QUESTION_LEAD_TYPE]?.value;
  let leadTypeBool = undefined;
  if (leadTypeAnswer === ANSWER_LEAD_TYPE_OPT_IN) {
    leadTypeBool = true;
  } else if (leadTypeAnswer === ANSWER_LEAD_TYPE_CASH_OFFER || leadTypeAnswer === ANSWER_LEAD_TYPE_OPT_OUT) {
    leadTypeBool = false;
  }
  const makeModelValue = replacementVehicle[QUESTION_MAKE_MODEL]?.value;
  let makeId = makeModelValue;
  let isValidMakeModelId = false;
  if (makeModelValue) {
    const makeModelRegex = /(mm\/\d+)\/(\d+)/;
    const match = makeModelValue.match(makeModelRegex);
    if (match) {
      makeId = match[1];
      makeId;
      isValidMakeModelId = true;
    }
  }

  const result = {
    replacementIsLookingForReplacementVehicle: leadTypeBool,
    replacementIsLookingForNewCars: replacementVehicle[QUESTION_NEW_CARS]?.value || false,
    replacementIsLookingForCertifiedCars: replacementVehicle[QUESTION_CERTIFIED_CARS]?.value || false,
    replacementIsLookingForUsedCars: replacementVehicle[QUESTION_USED_CARS]?.value || false,
    replacementMinYear: parseInt(replacementVehicle[QUESTION_YEAR_RANGE]?.value?.split(',')[0]) || null,
    replacementMaxYear: parseInt(replacementVehicle[QUESTION_YEAR_RANGE]?.value?.split(',')[1]) || null,
    replacementMakeModelId: replacementVehicle[QUESTION_MAKE_MODEL]?.value,
    replacementMakeId: makeId,
    isValidMakeModelId,
  };
  return result;
}

export function getKeysModificationsProperties(answerState) {
  const hasTwoSetsOfKeys = answerState.history;
  const hasToggleMods = answerState.conditions;
  return {
    ...hasTwoSetsOfKeys,
    ...hasToggleMods,
  };
}

export function hasAnsweredQuestions(questions = [], answers = {}) {
  const hasValidAnswer = questions.some((q) => {
    const value = answers[q.questionId]?.value;
    if (isValidValue(value)) {
      return true;
    }
    return false;
  });
  return hasValidAnswer ? 1 : 0;
}
export function multiselectHasAnsweredQuestions(questions = [], answers = {}) {
  let hasAnsweredQuestions = false;
  questions.forEach((q) => {
    if (q.selectChoices.length > 0) {
      q.selectChoices.some((q) => {
        const value = answers[q.qRef]?.value;
        if (isValidValue(value)) {
          hasAnsweredQuestions = true;
        }
      });
    }
  });
  return hasAnsweredQuestions ? 1 : 0;
}

export function getAnsweredQuestionCount(questions = [], answers = {}) {
  let badgeCount = 0;

  questions.map((q) => {
    const value = answers[q.questionId]?.value;
    if (isValidValue(value)) {
      badgeCount++;
    }
  });

  return badgeCount;
}

export function removeTypes(answers = []) {
  return answers.map((q) => {
    if (q.hasOwnProperty('type')) {
      return { questionId: q.questionId, value: q.value };
    }
    return q;
  });
}

export const getModificationsResponse = (aftermarketState) => {
  const modsDetails = Object.entries(aftermarketState.userInteraction).filter(([key]) => key !== 'twokeys' && key !== 'mods');
  const modDetailsValue = modsDetails.map(([, value]) => value).join('::');
  const modDetaislFields = modsDetails.map(([key]) => (key === 'wheelstires' ? 'wheels-tires' : key)).join('::');
  const { twokeys: keysValue, mods: modsValue } = aftermarketState.userInteraction;

  const responseFields = `keys::mods::${modDetaislFields}`;
  const responseValues = `${keysValue}::${modsValue}::${modDetailsValue}`.replace(/true/g, 'yes').replace(/false/g, 'no');

  return { icoResponses: { responseFields, responseValues } };
};
